import { Component } from "preact";
import "./style.scss";
import playButton from "./logo.svg";
import pauseButton from "./pause.svg";
// import audioSource from './silence.mp3';
import moment from "moment";
import AdSense from "react-adsense";
import SanitizedHTML from "react-sanitized-html";

import injectSheet from "react-jss";
const styles = {
  wrapper: {
    maxWidth: "420px",
    minHeight: "100%",
    paddingBottom: 20,
    backgroundColor: "#213a4a",
    "@media (min-height:700px)": {
      height: "750px"
    }
  },
  mainContent: {
    marginBottom: 15
  },
  header: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  logo: {
    height: 80,
    top: 4,
    marginTop: 12,
    position: "relative",
    "@media (max-width:370px)": {
      height: 60
    }
  },
  player: {
    height: 40,
    "@media (max-width:370px)": {
      height: 30
    }
  },
  show: {
    width: "100%",
    position: "relative",
    marginBottom: "-5px"
  },
  showImage: {
    height: "100%",
    width: "100%",
    backgroundSize: "cover"
  },
  overlay: {
    width: "fit-content",
    bottom: "2rem",
    height: "50px",
    display: "flex",
    position: "absolute",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
    left: "1rem",
    padding: "0 .5rem"
  },
  showText: {
    color: "#2C2C2C",
    fontSize: 25,
    fontWeight: "bold",
    textOverflow: "ellipsis",
    overflow: "hidden",
    maxWidth: `${window.innerWidth * 0.8}px`,
    whiteSpace: "nowrap",
    "@media (max-width:370px)": {
      fontSize: 20
    }
  },
  footer: {
    width: "95%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 10,
    background: "#1C4885",
    top: "-7px"
  },
  adWrapper: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: 15
  },
  ad: {
    width: 300,
    height: 250,
    margin: "0 auto",
    backgroundColor: process.env.NODE_ENV === "production" ? null : "#ccc",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "@media (max-width:370px)": {
      width: 250,
      height: 200
    }
  },
  nowLive: {
    position: "absolute",
    top: "-3.5rem",
    left: 0,
    color: "white",
    background: "red",
    padding: "1rem",
    fontWeight: "bold"
  },
  marquee: {
    color: "#ffc70f",
    marginRight: ".3rem"
  }
};
class App extends Component {
  isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  constructor() {
    super();
    this.state = {
      show: {},
      isPlaying: false,
      loaded: false,
      title: null
    };
  }

  fetchStreamInfo() {
    fetch("https://pocketfriendlytowns.com/gbfmaudio/")
      .then(res => res.json())
      .then(res => {
        if (res && res.title && res.title.length > 2)
          this.setState({ title: res.title });
      })
      .catch(e => console.error(e));
  }

  componentDidMount() {
    var config = {
      apiKey: "AIzaSyDcWo7PRCT_uig10R8LCHfNb5ezC-AvUtc",
      authDomain: "galwaybayfm-fd400.firebaseapp.com",
      databaseURL: "https://galwaybayfm-fd400.firebaseio.com",
      projectId: "galwaybayfm-fd400",
      storageBucket: "galwaybayfm-fd400.appspot.com",
      messagingSenderId: "501715094033"
    };
    firebase.initializeApp(config);

    setTimeout(() => {
      // :(
      firebase
        .firestore()
        .collection("shows")
        .get()
        .then(r => {
          const shows = r.docs.map(d => d.data());
          const today = moment().day();
          const index = today === 0 ? 6 : today - 1;
          const todayShows = shows.filter(
            s => s.schedule[index] && s.schedule[index].start
          );

          const now = moment();
          for (let show of todayShows) {
            const todaySchedule = show.schedule[index];
            const hours = moment.unix(todaySchedule.start.seconds).hours();
            const minutes = moment.unix(todaySchedule.start.seconds).minutes();

            const hoursF = moment
              .unix(todaySchedule.finish ? todaySchedule.finish.seconds : 0)
              .hours();
            const minutesF = moment
              .unix(todaySchedule.finish ? todaySchedule.finish.seconds : 0)
              .minutes();

            const showStart = moment()
              .hours(hours)
              .minutes(minutes)
              .add("hour", 1);
            const showEnd = moment()
              .hours(hoursF)
              .minutes(minutesF)
              .add("hour", 1);

            if (now.isBetween(showStart, showEnd)) {
              this.setState({ show }, () => {
                const img = new Image();
                img.src = `https://galwaybayfm.ie${show.image}`;
                img.onload = () => this.setState({ loaded: true });
              });
            }
          }
        }, 500); // END :(
    });

    const audio = new Audio();
    audio.src = "https://wg.cdn.tibus.net/galwaybay.mp3";

    new Image().src =
      "https://galwaybayfm.ie/wp-content/uploads/2019/01/gbfm2web.png";

    this.fetchStreamInfo();
    setInterval(() => {
      this.fetchStreamInfo();
    }, 10000);
  }

  render(props) {
    if (!this.state.loaded) return null;
    let html = this.state.title
      ? this.state.title
          .replace(/(<([^>]+)>)/gi, "")
          .replace(/(&#[\w]*;?)/gi, "")
      : "";
    if (html.toLowerCase().indexOf("of galway") <= 0)
      html = `Now playing: ${html}`;

    return (
      <div className={this.props.classes.wrapper}>
        {/* <iframe src="./silence.mp3" allow="autoplay" id="audio" style="display:none"></iframe> */}
        <div className="loadedContent">
          <div className={this.props.classes.mainContent}>
            <div className={this.props.classes.header}>
              <img
                src="https://galwaybayfm.ie/wp-content/uploads/2019/01/gbfm2web.png"
                className={this.props.classes.logo}
              />
            </div>

            <div className={this.props.classes.show}>
              <img
                src={`https://galwaybayfm.ie${this.state.show.image || ""}`}
                className={this.props.classes.showImage}
              />

              <div className={this.props.classes.overlay}>
                <span className={this.props.classes.nowLive}>NOW ON AIR </span>
                <span className={this.props.classes.showText}>
                  {this.state.show.title}
                </span>
              </div>
            </div>
            <div className={this.props.classes.footer}>
              <marquee className={this.props.classes.marquee}>
                {<SanitizedHTML html={html} />}
              </marquee>
              <img
                src={this.state.isPlaying ? pauseButton : playButton}
                className={this.props.classes.player}
                onClick={() => this.playSound()}
              />
            </div>
            <audio
              ref={ref => (this.audio = ref)}
              src="https://wg.cdn.tibus.net/galwaybay.mp3"
              onCanPlay={() => this.onLoad()}
            />
          </div>

          <div
            className={this.props.classes.adWrapper}
            style={this.isSafari ? { marginTop: 30 } : {}}
          >
            {this.getAd()}
          </div>
        </div>
      </div>
    );
  }

  onLoad() {
    setTimeout(() => {
      this.playSound();
    }, 500);
  }

  playSound() {
    const oldState = this.state.isPlaying;
    try {
      if (oldState) {
        this.audio.pause();
        this.setState({ isPlaying: false });
      } else {
        this.audio.play();
        this.setState({ isPlaying: true });
      }
    } catch (e) {
      this.setState({ isPlaying: oldState });
    }
  }

  getAd() {
    if (process.env.NODE_ENV === "production") {
      return (
        <div className={this.props.classes.ad}>
          <AdSense.Google
            client="ca-pub-1896095570155502"
            slot="4523878276"
            style={{ width: "90%", height: "90%" }}
            format=""
          />
        </div>
      );
    } else {
      return (
        <div className={this.props.classes.ad}>
          <div style={{ width: "90%", height: "90%", background: "red" }}></div>
        </div>
      );
    }
  }
}

export default injectSheet(styles)(App);



// WEBPACK FOOTER //
// ./components/main/index.js